import React from 'react';
import { Field } from 'redux-form';
import RenderField from './RenderField';
import { camelCase } from 'lodash/fp';

// default values to true
export const SECTIONS = [
  { name: 'site-stability-summary', label: 'Site Stability Summary' },
  { name: 'soil', label: 'Soil' },
  { name: 'liquefaction', label: 'Liquefaction' },
  { name: 'landslide', label: 'Landslide' },
  { name: 'fault-rupture', label: 'Fault Rupture' },
  { name: 'tsunami', label: 'Tsunami' },
  { name: 'faults', label: 'Nearby Faults' },
  { name: 'disaggregation', label: 'Ground Shaking Disaggregation' },
  { name: 'hazards', label: 'Ground Shaking Hazards' },
  { name: 'historic-shaking', label: 'Shake Maps' },
  { name: 'dam-inundation', label: 'Dam Inundation' },
];

export const sectionFormat = section => camelCase(`section-${section.name}`);

const ReportSectionsToInclude = () => (
  <div className="row">
    {SECTIONS.map(section => (
      <div key={`div_${sectionFormat(section)}`} className="col-sm-12">
        <Field
          label={section.label}
          id={sectionFormat(section)}
          name={sectionFormat(section)}
          component={RenderField}
          type="checkbox"
        />
      </div>
    ))}
  </div>
);

export default ReportSectionsToInclude;
